export default "__VITE_ASSET__BlhKVgnU__"